import React from 'react'
export default class Container extends React.PureComponent {
  render() {
    return <div className="container">{this.props.children}</div>
  }
}
